
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import calendar from './calendar';
import * as time from '../js/timeformat';
var mobdate = null;
import Lunar from '../js/shouxing.js'
export default {
name: 'index',
data () {
return {
value: '',
testNumber:13546488,
jieshao:false,
calendarShow: false,
birthday: '',
name:'',
headpic:'',
nickname:'',
id:'',
str:'',
noneli:'11',
lunar: null,
showQRcode:false,
wxList:[
{
title:'火思维',
content:'代表思维的开放性和驱动力，火思维强的人有动力；容易具有精力旺盛、活跃好动、热情积极、兴趣广泛、乐于奉献等特点；火思维工具是问题机会轮;'
},
{
title:'水思维',
content:'代表思维的灵活性和应变力，水思维强的人想得活；容易具有灵活变通、柔和冷静、谦虚委婉，擅长交流、耐心长久等特点；水思维工具是三门系统;'
},
{
title:'金思维',
content:'代表思维的逻辑性和延拓力，金思维强的人想得深；容易具有思维深刻、洞察力强、果断坚定、重视原则、勇于承担等特点；金思维工具是根;'
},
{
title:'土思维',
content:'代表思维的落地性和实践力，土思维强的人愿意做；容易具有认真务实、踏实肯干，顾全细节、宽厚包容、善于聚拢资源人脉等特点；土思维工具是地盘;'
},
{
title:'木思维',
content:'代表思维的整体性和系统力，木思维强的人想得全；容易具有爱动脑筋、创意不断、思维缜密、顾全大局、喜欢自由思考等特点；木思维工具是微弦。'
},
]
}
},
directives: {
TransferDom
},
components: {
XInput,
XButton,
Group,
Cell,
XDialog,
calendar
},
watch:{
name(val){
var reg = new RegExp("^[A-Za-z0-9\u4e00-\u9fa5]+$");

if(!reg.test(val[val.length-1])){
this.name = this.name.slice(0,this.name.length-1)


}

}
},
created: function () {
this.lunar = new Lunar();
console.log(this.lunar)
},
mounted: function () {
this.id = this.$route.query.id
this.$http.post('/wuxingExchangeSelect',{id:this.$route.query.id}).then(res=>{
if(res.body.code===0){
this.id = JSON.parse(res.body.result[0].message).user_id
this.$http.post('/wuxingUserinfo',{user_id:this.id}).then((ress)=>{
console.log(ress)
if(ress.body.code===0){
this.nickname = ress.body.result[0].nickname
this.headpic = ress.body.result[0].headpic
}
})
}
})
this.$http.post('/wuxingCount').then(res =>{
console.log(res)
if(res.body.code===0){
this.testNumber = res.body.result[0].TestCount
}
})











mobdate = mobiscroll.date('#scroller', {

theme: 'ios',
monthNames: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
display: 'bottom', //显示方式 bubble bottom center inline


anchor: '#scroller',
layout: "fixed",


showLabel: true,


headerText: '{value}<br><span style="font-size:12px;color:#999" id="nongli">'+this.changeNongli("1980-1-1")+'</span>',

defaultValue:new Date(1980,1-1,1),
cssClass:'hh',
buttons: [{
text: '取消',

handler: (event, inst) => {
inst.hide();
}
}, {
text: '完成',

handler:  (event, inst) => {
this.birthday = time.dateArr(inst.getVal(true)).date;




inst.cancel();
}
}],






onChange: ((event, inst)=>{
console.log(event,inst)
this.birthday = event.valueText
this.changeNongli(this.birthday,'change')
}),
onClose: function (event, inst) {
mobdate.setVal(new Date(1980,0,1))
},
dateFormat: 'yyyy-mm-dd',
lang: 'zh',
});
mobdate.hide();
},
methods: {
toKefu(){
wx.miniProgram.navigateTo({url: '/pages/kefu/main'})
},
changeNongli(date,type){
console.log(date)
let newDate = date.split('-');
let [tY,tM,tD] = ['','','']
tY = parseInt(newDate[0]);
tM = parseInt(newDate[1]) - 1;
tD = parseInt(newDate[2].split(' ')[0]);
this.lunar.yueLiCalc(tY, tM + 1);
let lunarD = this.lunar.lun[tD - 1];
this.nongli = lunarD.Lyear2 + '年' + lunarD.Lmc + '月' + lunarD.Ldc;
type==='change'?document.getElementById('nongli').innerText = lunarD.Lyear2 + '年' + lunarD.Lmc + '月' + lunarD.Ldc:null
return this.nongli
},
showBirthday(){
mobdate.show();
},
toMy(){
this.$router.push('/my?id=' + this.$route.query.id)
},
toMore(){
this.$router.push('/more?id=' + this.id)
},
calendarClose: function(data) {

this.calendarShow = data.flag;
this.birthday = data.birthday;
},
submit(){
this.$http.post('/wuxingTest',{nickname:this.name,birthday:this.birthday,user_id:this.id+''}).then(res =>{
if(res.body.code===0){

this.$router.push('/result?id=' + res.body.result)
}
console.log(res)
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/tiwn.vue